<template>
  <div>
    <my-header :breadcrumb="breadcrumb"></my-header>
    <div class="page-content">
      <el-row>
        <el-col :span="8" v-for="(item,index) in tableData" :key="index">
          <div class="grid-content bg-purple">
            <img :src="item.preview_img" />
            <p class="template-op">
              <a :href="siteUrl+'?templateName='+item.template_name" target="_blank">预览</a>
              <a href="javascript:;" v-if="item.template_name == site.template_name">已使用</a>
              <a :href="siteUrl+'?template_id='+item.id+'&isEdit=1&access_token='+access_token" v-if="item.template_name == site.template_name" target="_blank">编辑</a>
              <a href="javascript:;" @click="clickUpdateTemplate(item.template_name)" v-else>立即使用</a>
            </p>
          </div>
        </el-col>
        <el-col :span="8"><div class="grid-content bg-purple-light"></div></el-col>
        <el-col :span="8"><div class="grid-content bg-purple"></div></el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
  import MyHeader from '../header'
  import Cookies from 'js-cookie'
  export default {
    name: 'Index',
    components: {MyHeader},
    data() {
      return {
        form: {},
        formLabelWidth:'120px',
        tableData: [],
        totalCount: 0,
        pageCount: 1,
        breadcrumb: [
          {
            name: '系统设置'
          },
          {
            name: '模板列表'
          }
        ],
        dialogFormVisible:false,
        siteId:0,
        siteUrl:'',
        site:{},
        access_token:''
      }
    },
    created(){
      this.siteId = Cookies.get('siteId')
      this.access_token = Cookies.get('access_token')
      this.siteUrl = 'http://'+this.siteId+'.'+this.siteDomain;
      this.$http.get('/v1/site-template/index').then(({data})=>{
        this.tableData = data;
      })
      this.$http.get('/v1/sites/view?siteId='+this.siteId).then(({data})=>{
        this.site = data.result;
      })
      //console.log(this.form)
    },
    methods:{
      clickAdd(){
        this.dialogFormVisible = true;
      },
      clickConfirm(){

      },
      handleEdit(index,row){
        this.dialogFormVisible = true;
        this.$http.get(this.apiUrl+'/v1/nav/view?navId='+row.nav_id).then(({data})=>{
          this.form = data.result;
        })
      },
      handleDelete(){

      },
      clickUpdateTemplate(templateName){
        this.$http.get('/v1/sites/update-template',{params:{siteId:Cookies.get('siteId'),templateName:templateName}}).then(({data})=>{
          if (data.errcode == 0){
            this.$message.success(data.msg)
          }else{
            this.$message.error(data.msg)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .grid-content{
    text-align: center;
  }
  .template-op{
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
  }
  .template-op a:nth-child(2),.template-op a:nth-child(3){
    margin: 0 0 0 20px;
  }
</style>
